"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import Image from "next/image";
import { LOGO_TICKER_ITEMS } from "@/data/logo-ticker-logos";

const LOGO_TICKER_DURATION = 60;

type LogoTickerProps = {
  /** Retarde le défilement jusqu'à la fin de l'entrée hero (secondes). */
  scrollDelay?: number;
};

export function LogoTicker({ scrollDelay = 0 }: LogoTickerProps) {
  const prefersReducedMotion = useReducedMotion();

  return (
    <section aria-label="Nos clients" className="w-full overflow-hidden py-0">
      <div className="relative mx-auto w-full max-w-2xl overflow-hidden before:pointer-events-none before:absolute before:inset-y-0 before:left-0 before:z-10 before:w-12 before:bg-gradient-to-r before:from-[#f3f3f3] before:via-[#f3f3f3]/70 before:to-transparent before:content-[''] sm:max-w-3xl sm:before:w-16 after:pointer-events-none after:absolute after:inset-y-0 after:right-0 after:z-10 after:w-12 after:bg-gradient-to-l after:from-[#f3f3f3] after:via-[#f3f3f3]/70 after:to-transparent after:content-[''] sm:after:w-16">
        <motion.div
          className="flex w-max gap-12 pr-12 sm:gap-16 sm:pr-16"
          initial={{ translateX: 0 }}
          animate={prefersReducedMotion ? { translateX: 0 } : { translateX: "-50%" }}
          transition={{
            delay: scrollDelay,
            duration: LOGO_TICKER_DURATION,
            ease: "linear",
            repeat: prefersReducedMotion ? 0 : Infinity,
          }}
        >
          {[...new Array(2)].map((_, index) => (
            <React.Fragment key={index}>
              {LOGO_TICKER_ITEMS.map(({ src, alt, width, height }, logoIndex) => (
                <Image
                  key={`${index}-${alt}`}
                  src={src}
                  alt={alt}
                  width={width}
                  height={height}
                  priority={index === 0 && logoIndex < 4}
                  className="h-8 w-auto flex-none object-contain sm:h-9"
                />
              ))}
            </React.Fragment>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
